import { serializable, alias, object, list, primitive } from 'serializr';

export class EmissionEachStage {
  @serializable(alias('productRawMaterial', primitive()))
  productRawMaterial?: number ;

  @serializable(alias('productTransportation', primitive()))
  productTransportation?: number ;

  @serializable(alias('processingFacility', primitive()))
  processingFacility?: number ;

  @serializable(alias('productDistribution', primitive()))
  productDistribution?: number;

  @serializable
  total?: number;
}